module.exports = __webpack_public_path__ + "img/bus-outline-blue.c3158bc3.svg";